export const getVendorBadgeColor = status => {
  switch (status) {
    case 'draft':
      return 'light';

    case 'waiting_for_approval':
      return 'warning';

    case 'approved':
      return 'success';

    default:
      return 'light';
  }
};
